<!-- header -->

<div class="sfdc-configuration-content" mat-dialog-title>
  <div class="ncrInfo-container">

    <!-- Headings -->

    <h2 *ngIf="data?.moduleId == 3 && data?.rcaLayoutType">{{
      data?.rcaLayoutType}}</h2>

    <h3 *ngIf="data?.moduleId == 1">{{ data?.ncrIdDesc }}</h3>
    <h3 *ngIf="data?.moduleId == 2">CCR-{{ data?.ccrID }}</h3>
    <h3 *ngIf="data?.moduleId == 4 && data?.['KPI Name']">
      {{ data?.['KPI Name'] }}
    </h3>
    <h3 *ngIf="data?.moduleId == 3 && data?.meetingName">
      {{ data?.meetingName }}
    </h3>
    <h3 *ngIf="data?.moduleId == 3 && data?.KPIId">{{ data?.KPIName }}</h3>

    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close" class="close-btn"
      (click)="closePopUpModal()">
      <i class="fa fa-times" style="color: #fff"></i>
    </button>
  </div>
</div>

<!-- tabes -->
<div mat-dialog-content>
  <ng-container *ngIf="layoutShowHide()">
    <form name="searchDefectForm" [formGroup]="searchDefectForm" #formDirective="ngForm"
      (ngSubmit)="onSubmit(searchDefectForm, formDirective)">
      <div class="w-100 headerForm">

        <mat-form-field appearence="fill" class="w-22">
          <mat-label>Department</mat-label>
          <mat-select [(ngModel)]="headerData.Dept" formControlName="department" (selectionChange)="getUniqueCode()">
            <mat-select-filter [placeholder]="'Search Department'" [displayMember]="'TypeName'" [array]="deparmentList"
              (filteredReturn)="deparmentFiltList = $event">
            </mat-select-filter>
            <mat-option *ngFor="let dept of deparmentFiltList" [value]="dept.TypeId">
              {{ dept.TypeName }}
            </mat-option>
          </mat-select>
          <mat-error>Department is required</mat-error>
        </mat-form-field>

        <mat-form-field appearence="fill" class="w-22">
          <mat-label>Team Leader</mat-label>
          <mat-select #selectTeamLeader [(ngModel)]="headerData.TeamLeader" formControlName="teamleader"
            (selectionChange)="addTeamLeader(headerData.TeamLeader)">
            <mat-select-filter [placeholder]="'Search User'" [displayMember]="'fullName'" [array]="employees"
              (filteredReturn)="employeesTemp = $event">
            </mat-select-filter>
            <mat-option *ngFor="let user of employeesTemp" [value]="user.employeeCode">
              {{ user.fullName }}
            </mat-option>
          </mat-select>
          <mat-error>Team Leader is required</mat-error>
        </mat-form-field>

        <mat-form-field appearence="fill" class="w-22">
          <mat-label>Participants</mat-label>
          <mat-select #selectParticipants [(ngModel)]="headerData.Team" formControlName="team" multiple
            (selectionChange)="setParticipantsChange(headerData.Team)">
            <mat-select-filter #selectParticipantsFilter [placeholder]="'Search User'" [displayMember]="'fullName'"
              [array]="employees" (filteredReturn)="participantsTemp = $event" (keyup)="keyUp()">
            </mat-select-filter>
            <mat-option *ngFor="let user of participantsTemp" [value]="user.employeeCode"
              [disabled]="headerData.TeamLeader == user.employeeCode" (click)="setTeamAndValidate(user.employeeCode)">
              {{ user.fullName }}
            </mat-option>
          </mat-select>
          <mat-error>Participants is required</mat-error>
        </mat-form-field>
        <mat-form-field appearence="fill" style="width: 14rem;" *ngIf="headerData?.uniqueCode != undefined">
          <mat-label>RCA Code</mat-label>

          <input matInput type="text" readonly [(ngModel)]="headerData.uniqueCode" formControlName="uniqueCode"
            *ngIf="headerData?.uniqueCode != undefined" />
        </mat-form-field>

        <button mat-flat-button color="accent" style="margin-left: 8rem;" type="button" class="upload" (click)="openFile()">
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
      <div class="w-100 headerForm" style="display: flex">
        <div *ngIf="stageID != 6" style="width: 74%; position: relative;" title="{{ headerData.InitProbStatement }}">
          <mat-form-field appearence="fill" class="w-70">
            <mat-label>Initial Problem Statement</mat-label>
            <textarea matInput [(ngModel)]="headerData.InitProbStatement" formControlName="initProbStat"
              [readonly]="!isShowAllowInitProb()" style="resize: vertical;"></textarea>
            <mat-error>Initial Problem Statement is required</mat-error>
          </mat-form-field>
        </div>
        <!-- <div *ngIf="stageID != 6" style="width: 20%; position: relative">
          <div class="imgflex">
            <img *ngIf="imageFile && imageSrc" (click)="imageZoomModal()" [src]="imageSrc" alt="" width="60px"
              height="40px" />
            <img *ngIf="
                !imageSrc && headerData && headerData.UploadFile && !isLoading
              " class="imgrel" (click)="imageZoomModal()" [src]="ImageUrl + headerData.UploadFile" alt="" width="60px"
              height="40px" />
            <img *ngIf="
                (imageFile && imageSrc) || (headerData.UploadFile && !isLoading)
              " src="assets/images/delete.png" (click)="deleteFile()" class="imgabsol" alt="" width="15px"
              height="15px" />
          
            <input type="file" (change)="readFile($event)" class="d-none" #fileInput accept="image/*" />
          </div>
        </div> -->

        <div class="btn-group">
          <button *ngIf="isCreate && !isView" type="submit" class="save" tooltipPosition="top" matTooltip="Save">
            <img src="assets/images/save.png" alt="" width="20px" height="20px" />
          </button>
        </div>
      </div>
    </form>
    
    <!-- Loading indicator while data is being fetched -->
    <div *ngIf="!isDataReady" style="text-align: center; padding: 20px;">
      <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
      <p style="margin-top: 10px; color: #666;">Loading data...</p>
    </div>
    
    <div class="header-tab" *ngIf="isDataReady">
      <ng-container *ngIf="!data?.hideTabs">
        <mat-tab-group #tabChange [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
          *ngIf="selectedIndex != 10" [dynamicHeight]="true" [disablePagination]="false">
          <mat-tab [disabled]="selectedRCA?.disableSixWTwo">
            <ng-template mat-tab-label>
              6W2H
              <span>{{ selectedRCA?.Status6W2H }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-at6w2h [destroy$]="destroy$" [sixWTwoh_]="sixWTwoh_" [_headerData]="_headerData" [headerID]="headerId"
                  (onSuccess)="nullifySubject($event)" [_integrationData]="_integrationData"></app-at6w2h>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab class="column-tab" [disabled]="selectedRCA?.disableFishbone">
            <ng-template mat-tab-label>
              FishBone
              <span>{{ selectedRCA?.StatusFishbone }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-fishbone [destroy$]="destroy$" [fishBone_]="fishBone_" [_headerData]="_headerData" [headerID]="headerId"
                  (onSuccess)="nullifySubject($event)" [_permission]="permisson" [_integrationData]="_integrationData">
                </app-fishbone>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab [disabled]="selectedRCA?.disableCauseAndEffect" label="Cause & Effect">
            <ng-template mat-tab-label>
              Cause & Effect
              <span>{{ selectedRCA?.StatusCauseEffect }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-cause-effect [destroy$]="destroy$" [causeAndEffects_]="causeAndEffects_" (onSuccess)="nullifySubject($event)"
                  [headerID]="headerId" [_headerData]="_headerData" [_permission]="permisson"
                  [_integrationData]="_integrationData"></app-cause-effect>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="5 Why" [disabled]="selectedRCA?.disableFiveWhy">
            <ng-template mat-tab-label>
              5 Why
              <span>{{ selectedRCA?.StatusFiveWhy }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-five-why [destroy$]="destroy$" [fiveWhy_]="fiveWhy_" (onSuccess)="nullifySubject($event)" [headerID]="headerId"
                  [_permission]="permisson" [_headerData]="headerData" [_integrationData]="_integrationData">
                </app-five-why>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
            <ng-template mat-tab-label>
              Action Plan
              <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-fivewhy-actionplan [destroy$]="destroy$" [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                  [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                  [_integrationData]="_integrationData"></app-fivewhy-actionplan>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
      <ng-container *ngIf="
          data?.hideTabs &&
          data?.moduleId === 3 &&
          data?.componentName === 'kpiView'
        ">
        <mat-tab-group #tabChange [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
          *ngIf="selectedIndex != 10" [dynamicHeight]="true" [disablePagination]="false">
          <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
            <ng-template mat-tab-label>
              Action Plan
              <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-fivewhy-actionplan [destroy$]="destroy$" [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                  [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                  [_integrationData]="_integrationData"></app-fivewhy-actionplan>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
      <ng-container *ngIf="
          data?.hideTabs &&
          data?.moduleId === 3 &&
          data?.componentName === 'meeting-matrixV2'&&
          data?.showRCA 
        ">
        <mat-tab-group #tabChange [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
          *ngIf="selectedIndex != 10" [dynamicHeight]="true" [disablePagination]="false">
          <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
            <ng-template mat-tab-label>
              Action Plan
              <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content">
                <app-fivewhy-actionplan [destroy$]="destroy$" [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                  [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                  [_integrationData]="_integrationData"></app-fivewhy-actionplan>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
    </div>
  </ng-container>

  <!-- meeting matrix v2 -->
  <ng-container *ngIf="!layoutShowHide()">
    <div class="d-flex flex-column">
      <form name="searchDefectForm" [formGroup]="searchDefectForm" #formDirective="ngForm"
        (ngSubmit)="onSubmit(searchDefectForm, formDirective)">
        <div class="w-100 headerForm">
          <mat-form-field appearence="fill" class="w-22 " [class.d-none]="data?.rcaLayoutType=='Action'">
            <mat-label>Group</mat-label>
            <mat-select [(ngModel)]="headerData.Group" formControlName="group" (selectionChange)="getDeptData()"
              disabled>
              <mat-select-filter [placeholder]="'Search Group'" [displayMember]="'TypeName'" [array]="groupList"
                (filteredReturn)="groupTempList = $event" disabled>
              </mat-select-filter>

              <mat-option *ngFor="let group of groupTempList" [value]="group.TypeId">
                {{ group.TypeName }}
              </mat-option>
            </mat-select>
            <mat-error>Group is required</mat-error>
          </mat-form-field>
          <mat-form-field appearence="fill" class="w-22 " [class.d-none]="data?.rcaLayoutType=='Action'">
            <mat-label>Plant</mat-label>
            <mat-select [(ngModel)]="headerData.Plant" formControlName="plant" (selectionChange)="
              getAllDepartment(); getTeamList(); emitPlantChange()
            " disabled>
              <mat-select-filter [placeholder]="'Search Plant'" [displayMember]="'DeptDesc'" [array]="plantList"
                (filteredReturn)="plantTempList = $event" disabled>
              </mat-select-filter>

              <mat-option *ngFor="let plant of plantTempList" [value]="plant.DeptId">
                {{ plant.DeptDesc }}
              </mat-option>
            </mat-select>
            <mat-error>Plant is required</mat-error>
          </mat-form-field>
          <mat-form-field appearence="fill" class="w-22">
            <mat-label>Department</mat-label>
            <mat-select [(ngModel)]="headerData.Dept" formControlName="department" (selectionChange)="getUniqueCode()">
              <mat-select-filter [placeholder]="'Search Department'" [displayMember]="'TypeName'" [array]="deptList"
                (filteredReturn)="deptTempList = $event">
              </mat-select-filter>
              <mat-option *ngFor="let dept of deptTempList" [value]="dept.TypeId">
                {{ dept.TypeName }}
              </mat-option>
            </mat-select>
            <mat-error>Department is required</mat-error>
          </mat-form-field>
          <ng-container *ngIf="data?.rcaLayoutType=='Action'">
            <mat-form-field appearence="fill" class="w-10" *ngIf="headerData?.uniqueCode != undefined"
              [class.d-none]="data?.rcaLayoutType=='Action'">
              <mat-label>RCA Code</mat-label>

              <input matInput type="text" readonly [(ngModel)]="headerData.uniqueCode" formControlName="uniqueCode"
                *ngIf="headerData?.uniqueCode != undefined" />
            </mat-form-field>
            <button mat-flat-button color="accent" style="margin-left: 5rem;" type="button" class="upload" (click)="openFile()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <div class="btn-group">
              <button *ngIf="isCreate" type="submit" class="save" tooltipPosition="top" matTooltip="Save">
                <img src="assets/images/save.png" alt="" width="20px" height="20px" />
              </button>
            </div>
          </ng-container>
          <mat-form-field appearence="fill" class="w-22">
            <mat-label>Team Leader</mat-label>
            <mat-select #selectTeamLeader [(ngModel)]="headerData.TeamLeader" formControlName="teamleader"
              (selectionChange)="addTeamLeader(headerData.TeamLeader)">
              <mat-select-filter [placeholder]="'Search User'" [displayMember]="'fullName'" [array]="employees"
                (filteredReturn)="employeesTemp = $event">
              </mat-select-filter>
              <mat-option *ngFor="let user of employeesTemp" [value]="user.employeeCode">
                {{ user.fullName }}
              </mat-option>
            </mat-select>
            <mat-error>Team Leader is required</mat-error>
          </mat-form-field>
          <mat-form-field appearence="fill" class="w-22">
            <mat-label>Participants</mat-label>
            <mat-select #selectParticipants [(ngModel)]="headerData.Team" formControlName="team" multiple
              (selectionChange)="setParticipantsChange(headerData.Team)">
              <mat-select-filter #selectParticipantsFilter [placeholder]="'Search User'" [displayMember]="'fullName'"
                [array]="employees" (filteredReturn)="participantsTemp = $event" (keyup)="keyUp()">
              </mat-select-filter>
              <mat-option *ngFor="let user of participantsTemp" [value]="user.employeeCode"
                [disabled]="headerData.TeamLeader == user.employeeCode" (click)="setTeamAndValidate(user.employeeCode)">
                {{ user.fullName }}
              </mat-option>
            </mat-select>
            <mat-error>Participants is required</mat-error>
          </mat-form-field>

        </div>
        <div class="w-100 headerForm" style="display: flex" [class.d-none]="data?.rcaLayoutType=='Action'">
          <div *ngIf="stageID != 6" style="width: 77%; position: relative" title="{{ headerData.InitProbStatement }}">
            <mat-form-field appearence="fill" class="w-70">
              <mat-label>Initial Problem Statement</mat-label>
              <input matInput [(ngModel)]="headerData.InitProbStatement" formControlName="initProbStat"
                [readonly]="isShowAllowInitProb()" />
              <mat-error>Initial Problem Statement is required</mat-error>
            </mat-form-field>

            <div class="imgflex">
              <img *ngIf="imageFile && imageSrc" (click)="imageZoomModal()" [src]="imageSrc" alt="" width="60px"
                height="40px" />
              <img *ngIf="
                !imageSrc && headerData && headerData.UploadFile && !isLoading
              " class="imgrel" (click)="imageZoomModal()" [src]="ImageUrl + headerData.UploadFile" alt="" width="60px"
                height="40px" />
              <img *ngIf="
                (imageFile && imageSrc) || (headerData.UploadFile && !isLoading)
              " src="assets/images/delete.png" (click)="deleteFile()" class="imgabsol" alt="" width="15px"
                height="15px" />
              
              <input type="file" (change)="readFile($event)" class="d-none" #fileInput accept="image/*" />
            </div>
          </div>
          <mat-form-field appearence="fill" class="w-10" *ngIf="headerData?.uniqueCode != undefined"
            [class.d-none]="data?.rcaLayoutType=='Action'">
            <mat-label>RCA Code</mat-label>

            <input matInput type="text" readonly [(ngModel)]="headerData.uniqueCode" formControlName="uniqueCode"
              *ngIf="headerData?.uniqueCode != undefined" />
          </mat-form-field>
          <div class="btn-group">
            <button *ngIf="isCreate" type="submit" class="save" tooltipPosition="top" matTooltip="Save">
              <img src="assets/images/save.png" alt="" width="20px" height="20px" />
            </button>
          </div>
        </div>
      </form>
      <div class="header-tab">
        <ng-container *ngIf="!data?.hideTabs">
          <mat-tab-group #tabChange [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
            *ngIf="selectedIndex != 10" [dynamicHeight]="true" [disablePagination]="false">
            <mat-tab [disabled]="selectedRCA?.disableSixWTwo">
              <ng-template mat-tab-label>
                6W2H
                <span>{{ selectedRCA?.Status6W2H }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-at6w2h [destroy$]="destroy$" [sixWTwoh_]="sixWTwoh_" [_headerData]="_headerData" [headerID]="headerId"
                    (onSuccess)="nullifySubject($event)" [_integrationData]="_integrationData"></app-at6w2h>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab class="column-tab" [disabled]="selectedRCA?.disableFishbone">
              <ng-template mat-tab-label>
                FishBone
                <span>{{ selectedRCA?.StatusFishbone }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-fishbone [destroy$]="destroy$" [fishBone_]="fishBone_" [_headerData]="_headerData" [headerID]="headerId"
                    (onSuccess)="nullifySubject($event)" [_permission]="permisson" [_integrationData]="_integrationData">
                  </app-fishbone>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab [disabled]="selectedRCA?.disableCauseAndEffect" label="Cause & Effect">
              <ng-template mat-tab-label>
                Cause & Effect
                <span>{{ selectedRCA?.StatusCauseEffect }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-cause-effect [destroy$]="destroy$" [causeAndEffects_]="causeAndEffects_" (onSuccess)="nullifySubject($event)"
                    [headerID]="headerId" [_headerData]="_headerData" [_permission]="permisson"
                    [_integrationData]="_integrationData"></app-cause-effect>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab label="5 Why" [disabled]="selectedRCA?.disableFiveWhy">
              <ng-template mat-tab-label>
                5 Why
                <span>{{ selectedRCA?.StatusFiveWhy }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-five-why [destroy$]="destroy$" [fiveWhy_]="fiveWhy_" (onSuccess)="nullifySubject($event)" [headerID]="headerId"
                    [_permission]="permisson" [_headerData]="headerData" [_integrationData]="_integrationData">
                  </app-five-why>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
              <ng-template mat-tab-label>
                Action Plan
                <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-fivewhy-actionplan [destroy$]="destroy$" [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                    [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                    [_integrationData]="_integrationData"></app-fivewhy-actionplan>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </ng-container>
        <ng-container *ngIf="
            data?.hideTabs &&
            data?.moduleId === 3 &&
            data?.componentName === 'kpiView'
          ">
          <mat-tab-group #tabChange [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
            *ngIf="selectedIndex != 10" [dynamicHeight]="true" [disablePagination]="false">
            <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
              <ng-template mat-tab-label>
                Action Plan
                <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content">
                  <app-fivewhy-actionplan [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                    [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                    [_integrationData]="_integrationData"></app-fivewhy-actionplan>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </ng-container>
        <ng-container [ngSwitch]="data?.rcaLayoutType">
          <ng-container *ngSwitchCase="'Action'">
            <!-- Action -->
            <mat-tab-group (selectedTabChange)="onTabChangeMeetingAction($event)" [dynamicHeight]="true" [disablePagination]="false">
              <!-- Action -->
              <mat-tab>
                <ng-template mat-tab-label>
                  Action
                  <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>

                </ng-template>
                <ng-template matTabContent>
                  <app-fivewhy-actionplan [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                    [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                    [_integrationData]="_integrationData" [_showAnalysis]="showAnalysisSubject.asObservable()">
                  </app-fivewhy-actionplan>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </ng-container>
          <ng-container *ngSwitchCase="'RCA'">
            <!-- RCA -->
            <mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex" [dynamicHeight]="true" [disablePagination]="false">
              <mat-tab [disabled]="selectedRCA?.disableSixWTwo">
                <ng-template mat-tab-label>
                  6W2H
                  <span>{{ selectedRCA?.Status6W2H }}</span>
                </ng-template>
                <ng-template matTabContent>
                  <div class="tab-content">
                    <app-at6w2h [destroy$]="destroy$" [sixWTwoh_]="sixWTwoh_" [_headerData]="_headerData" [headerID]="headerId"
                      (onSuccess)="nullifySubject($event)" [_integrationData]="_integrationData"></app-at6w2h>
                  </div>
                </ng-template>
              </mat-tab>

              <mat-tab class="column-tab" [disabled]="selectedRCA?.disableFishbone">
                <ng-template mat-tab-label>
                  FishBone
                  <span>{{ selectedRCA?.StatusFishbone }}</span>
                </ng-template>
                <ng-template matTabContent>
                  <div class="tab-content">
                    <app-fishbone [destroy$]="destroy$" [fishBone_]="fishBone_" [_headerData]="_headerData" [headerID]="headerId"
                      (onSuccess)="nullifySubject($event)" [_permission]="permisson"
                      [_integrationData]="_integrationData">
                    </app-fishbone>
                  </div>
                </ng-template>
              </mat-tab>

              <mat-tab [disabled]="selectedRCA?.disableCauseAndEffect">
                <ng-template mat-tab-label>
                  Cause & Effect
                  <span>{{ selectedRCA?.StatusCauseEffect }}</span>
                </ng-template>
                <ng-template matTabContent>
                  <div class="tab-content">
                    <app-cause-effect [destroy$]="destroy$" [causeAndEffects_]="causeAndEffects_" (onSuccess)="nullifySubject($event)"
                      [headerID]="headerId" [_headerData]="_headerData" [_permission]="permisson"
                      [_integrationData]="_integrationData"></app-cause-effect>
                  </div>
                </ng-template>
              </mat-tab>

              <mat-tab label="5 Why" [disabled]="selectedRCA?.disableFiveWhy">
                <ng-template mat-tab-label>
                  5 Why
                  <span>{{ selectedRCA?.StatusFiveWhy }}</span>
                </ng-template>
                <ng-template matTabContent>
                  <div class="tab-content">
                    <app-five-why [destroy$]="destroy$" [fiveWhy_]="fiveWhy_" (onSuccess)="nullifySubject($event)" [headerID]="headerId"
                      [_permission]="permisson" [_headerData]="headerData" [_integrationData]="_integrationData">
                    </app-five-why>
                  </div>
                </ng-template>
              </mat-tab>

              <mat-tab label="Action Plan" [disabled]="selectedRCA?.disableActionPlan">
                <ng-template mat-tab-label>
                  Action Plan
                  <span>{{ selectedRCA?.StatusFiveWhyAction }}</span>
                </ng-template>
                <ng-template matTabContent>
                  <div class="tab-content">
                    <app-fivewhy-actionplan [actionPlan_]="actionPlan_" (onSuccess)="nullifySubject($event)"
                      [_headerData]="headerData" [headerID]="headerId" [_permission]="permisson"
                      [_integrationData]="_integrationData" [_showAnalysis]="showAnalysisSubject.asObservable()">
                    </app-fivewhy-actionplan>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </ng-container>
        </ng-container>


      </div>
    </div>
  </ng-container>
</div>